import React from "react";
import { Modal } from "../../SharedComponents";
import { LoginSteps } from "../../../Constants/loginSteps";
import { ModalNames } from "../../../Constants/modalNames";
import { Div, Text } from "../../Kit";
import { LoginForm } from "../LoginForm/LoginForm";
import { VerifyOtpForm } from "../VerifyOtpForm/VerifyOtpForm";
import { useAuth } from "../../../Store/modules/auth/authSlice";
import LamtakamLogo from "../../Icons/logo_small2X.png";

export const LoginModal: React.FC = () => {
  const { step } = useAuth();

  return (
    <Modal modalName={ModalNames.LoginModal} preventToClose={step === LoginSteps.VerifyOtp} modalClassName="rounded-[10px] w-[320px] h-[420px]">
      <Div className="flex flex-col justify-center items-center h-[385px]">
        <div className="flex justify-center w-full">
          <img src={LamtakamLogo} alt="lamtakam-logo" className="w-[41px] h-[43px]" />
        </div>
        <div className="flex flex-col items-center">
          <Text elementType="h3" className="text-[18px] mt-2" fontWeight={500}>
            login.loginForm.title
          </Text>
        </div>
        <div className="flex justify-center mt-[8px]">
          <div className="w-[248px] h-[1px] bg-[#E6EAEE]" />
        </div>
        {step === LoginSteps.LoginForm ? <LoginForm /> : null}
        {step === LoginSteps.VerifyOtp ? <VerifyOtpForm /> : null}
      </Div>
    </Modal>
  );
};
